<template>
  <transition name="vi-modal">
    <div class="contact-info-modal vi-modal" v-if="contact">
      <div class="vi-modal-content">
        <div class="close-modal" @click="onClose">
          <img src="../../assets/icon_clear.svg"/>
        </div>
        <div class="contact-info-text">
          {{contact.name}}
        </div>
        <div class="contact-info-text">
          <current-option :option="contact.type || 'sms'"/>
        </div>
        <div class="contact-info-text" v-if="contact.phoneNumber">{{contact.phoneNumber}}</div>
        <div class="contact-info-text" v-if="contact.email">{{contact.email}}</div>
        <div class="contact-info-text" v-if="contact.link">{{contact.link}}</div>
        <div class="text-center">
          <vi-button label="Copy link" @click="copyToClipBoard"/>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
  import CurrentOption from "./CurrentOption";
  import ViButton from "../ui/ViButton";
  export default {
    name: 'ContactInfoModal',
    components: {ViButton, CurrentOption},
    props: {
      contact: {
        type: Object
      }
    },
    methods: {
      onClose() {
        this.$emit('close')
      },
      copyToClipBoard() {
        let el = document.createElement('textarea');
        el.value = this.contact.link;
        el.setAttribute('readonly', '');
        el.style = {position: 'absolute', left: '-9999px'};
        document.body.appendChild(el);
        el.select();
        document.execCommand('copy');
        document.body.removeChild(el);
      },
      closeOnEscape(e) {
        if (e.which === 27) {
          this.onClose()
        }
      },
    },


    mounted() {
      document.addEventListener('keydown', this.closeOnEscape, false)
    },

    beforeDestroy() {
      document.removeEventListener('keydown', this.closeOnEscape, false)
    }
  }
</script>

<style lang="scss">
@import "ContactInfoModal";
</style>
